import { render, staticRenderFns } from "./OfficesBlock.vue?vue&type=template&id=2378624d"
import script from "./OfficesBlock.vue?vue&type=script&lang=js"
export * from "./OfficesBlock.vue?vue&type=script&lang=js"
import style0 from "./OfficesBlock.vue?vue&type=style&index=0&id=2378624d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports